// extracted by mini-css-extract-plugin
export default {"backButton":"back-button--LlBBBbfEKv3JmBIA_rS_","backIcon":"back-icon--bS5MAGIy5M_Q7KcZ60xy"};